/* Merkenpaneel onder SNEAKERS (snippets/sv-merkenmenu.liquid): wisselt
   tussen het logoraster, een merk en een familie. Alles gedelegeerd op
   document: het thema kopieert elk menu-item (ul-inner, show-all-submenu),
   dus er bestaan meerdere panelen naast elkaar. */
(function () {
  function mobiel() {
    return document.documentElement.classList.contains('m2a');
  }

  function toon(mm, naam) {
    var paneel = mm.querySelector('.sv-mm__paneel');
    // Desktop: het paneel opent op hover. Krimpt het bij een korter scherm
    // (Nike > Dunk heeft twee regels), dan staat de muis er ineens naast en
    // klapt het dicht (06-10). Daarom wordt het niet lager zolang het open is.
    if (paneel && naam !== 'merken' && !mobiel()) {
      paneel.style.minHeight = Math.max(paneel.offsetHeight, parseFloat(paneel.style.minHeight) || 0) + 'px';
    }
    var schermen = mm.querySelectorAll('.sv-mm__scherm');
    for (var i = 0; i < schermen.length; i++) {
      schermen[i].classList.toggle('is-actief', schermen[i].getAttribute('data-sv-mm-scherm') === naam);
    }
    if (paneel) paneel.scrollTop = 0;
  }

  function terug(mm) {
    toon(mm, 'merken');
    var paneel = mm.querySelector('.sv-mm__paneel');
    if (paneel) paneel.style.minHeight = '';
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var knop = e.target.closest('.sv-mm [data-sv-mm-open]');
    if (knop) {
      e.preventDefault();
      var mm = knop.closest('.sv-mm');
      toon(mm, knop.getAttribute('data-sv-mm-open'));
      var eerste = mm.querySelector('.sv-mm__scherm.is-actief a');
      if (eerste && e.detail === 0) eerste.focus();   // toetsenbord: focus mee
      return;
    }
    // Opent de lade het niveau SNEAKERS opnieuw, dan begint het bij het raster.
    var open = e.target.closest('.sv-mm > a.toggle, .sv-mm > a.toggle-back');
    if (open) terug(open.closest('.sv-mm'));
  }, true);

  // Desktop: weer naar het raster zodra het paneel dichtgaat.
  document.addEventListener('mouseout', function (e) {
    if (!e.target.closest || mobiel()) return;
    var mm = e.target.closest('.sv-mm');
    if (!mm || mm.contains(e.relatedTarget)) return;
    setTimeout(function () {
      if (!mm.matches(':hover') && !mm.contains(document.activeElement)) terug(mm);
    }, 250);
  });
})();
